import { render, staticRenderFns } from "./mallManagementEdit.vue?vue&type=template&id=43b70540&scoped=true"
import script from "./mallManagementEdit.vue?vue&type=script&lang=js"
export * from "./mallManagementEdit.vue?vue&type=script&lang=js"
import style0 from "./mallManagementEdit.vue?vue&type=style&index=0&id=43b70540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b70540",
  null
  
)

export default component.exports